import React from 'react';
import { EmailQueuedIcon, EmailDeliveredIcon, EmailErrorIcon } from '../icons';
import { Tooltip } from '@material-ui/core';

const emailStatusIcons = {
    queued: { icon: <EmailQueuedIcon />, label: 'Queued' },
    delivered: { icon: <EmailDeliveredIcon />, label: 'Delivered' },
    bounce: { icon: <EmailErrorIcon color="error" />, label: 'Bounced' },
    dropped: { icon: <EmailErrorIcon color="error" />, label: 'Dropped' },
    spamreport: { icon: <EmailErrorIcon color="error" />, label: 'Spam Reported' }
};

const EmailStatusIcon = ({ status, result }) => {
    const Icon = emailStatusIcons[status] || null;

    if (!Icon || result === 'created') {
        return '-';
    }

    return (
        <Tooltip title={Icon.label || ''}>
            <span
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {Icon.icon || null}
            </span>
        </Tooltip>
    );
};

export default EmailStatusIcon;
